import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { compose } from "underscore"

import { Message } from "~/shared/ui/kit"
import { withBootstrap } from "~/host-app/bootstrap/Bootstrap"
import { useNetworkStatus } from "~/shared/lib/hooks"
import { CommonErrorFallback, withErrorBoundary } from "~/shared/ui"

import { HostAppRouter as Router } from "./routing/HostAppRouter"

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			retry: false,
			staleTime: Infinity
		}
	}
})

/*function QueryCacheCleaner(props : PropsWithChildren) {
	const queryClient = useQueryClient()
	const userInfo = useUserInfo()

	useEffect(() => {

		if (!userInfo) queryClient.clear()

	}, [userInfo])

	return props.children
}*/

function HostApp() {
	const status = useNetworkStatus()

	if (!status)
		return (
			<Message
				className="flex items-center justify-center"
				style={{
					width: "100vw",
					height: "100vh"
				}}
				type="error"
			>
				<div className="text-[2rem]">Нет подключения к Интернету!</div>
			</Message>
		)

	return (
		<QueryClientProvider client={queryClient}>
				<Router />
		</QueryClientProvider>
	)
}

export default compose(
	withErrorBoundary(() => <CommonErrorFallback />),
	withBootstrap
)(HostApp)
